import { t } from "i18next"
import { Button, Card, Checkbox, Divider, Image, ImageUpload, Space } from "components/common"
import { useMemo, useState } from "react"
import { convertCamelCaseToReadable, convertToReadableString, downloadMultipleFiles, isPDF } from "utils"
import { Row, Col } from "antd"
import theme from "utils/themeVars"
import styles from "./index.module.less"
import cx from "clsx"
import Flex from "components/common/flex"

const MediaTab = props => {
  const { data } = props
  const [downloadUrls, setDownloadUrls] = useState([])
  const [media, setMedia] = useState(data?.mediaItems)

  const createFileList = attachments => {
    return attachments?.map(e => ({ id: e?.id, name: e?.name, title: e?.title, url: e?.src || e?.url }))
  }

  const updateSelectAll = section => {
    if (section) {
      const newArray = media.filter(item => item.section === section)
      return newArray.every(item => item.checkedState === true)
    }
  }
  const updateDownloadURLs = (isChecked, url = "", section = "") => {
    if (section) {
      if (isChecked) {
        media.forEach(file => {
          if (file.section === section) {
            setDownloadUrls(prevUrls => {
              if (!prevUrls.includes(file.url)) {
                return [...prevUrls, file.url]
              }
              return prevUrls
            })
          }
        })
      } else {
        media.forEach(file => {
          if (file.section === section) {
            setDownloadUrls(prevUrls => {
              return prevUrls.filter(url => url !== file.url)
            })
          }
        })
      }
    } else {
      if (isChecked) {
        setDownloadUrls(prevUrls => [...prevUrls, url])
      } else {
        setDownloadUrls(prevUrls => prevUrls.filter(item => item !== url))
      }
    }
  }

  const handleChange = (isChecked, file) => {
    setMedia(prevMedia => prevMedia.map(item => (item.id === file.id ? { ...item, checkedState: isChecked } : item)))
    updateDownloadURLs(isChecked, file.url)
  }

  const handleSelectAll = (section, isChecked) => {
    setMedia(prevMedia =>
      prevMedia.map(item => (item.section === section ? { ...item, checkedState: isChecked } : item))
    )
    updateDownloadURLs(isChecked, "", section)
  }

  const handleCancelClick = () => {
    setMedia(prevMedia => prevMedia.map(item => ({ ...item, checkedState: false })))
    setDownloadUrls([])
  }

  const downloadMedia = () => {
    if (downloadUrls) {
      downloadMultipleFiles(downloadUrls)
      handleCancelClick()
    }
  }

  const RenderMedia = e => {
    const result = useMemo(() => {
      if (isPDF(e?.url)) {
        return (
          <ImageUpload
            className={cx(styles.uploadMedia, styles.removeOverlay)}
            files={[{ ...e, type: "pdf" }]}
            noCard={true}
            showOnly={true}
            picture={true}
            allowPDFDownload={false}
            // outerStyle={{ width: 100, height: 100 }}
          />
        )
      } else {
        return <Image height={75} width={85} src={e?.url} alt="media" />
      }
    }, [data?.Images])
    return result
  }

  return (
    <div
      style={{
        maxHeight: "calc(100vh - 430px)",
        overflowY: "auto",
      }}
    >
      {Object.entries(data?.Images).map((item, index) => {
        return (
          !!Object.keys(item[1]).length && (
            <div className={cx(styles.mediaContainer)} key={index}>
              <Row
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
                className="mbe-8"
              >
                <strong>{t(convertCamelCaseToReadable(item[0]))}</strong>
                <Checkbox
                  checked={updateSelectAll(item[0])}
                  onChange={value => handleSelectAll(item[0], value.target.checked)}
                  className="fs12 link-color"
                >
                  {t("Select All")}
                </Checkbox>
              </Row>

              <Flex align="start" vertical gap="16px">
                {Array.isArray(item[1]) ? (
                  <Flex align="start" gap="8px">
                    {createFileList(item[1])?.map(e => {
                      const mediaItem = media.find(item => item.id === e.id)

                      return (
                        <div style={{ position: "relative", display: "inline-block" }}>
                          <Checkbox
                            checked={mediaItem?.checkedState}
                            onChange={value => {
                              handleChange(value.target.checked, e)
                            }}
                            className={styles.checkboxStyle}
                          />
                          {RenderMedia(e)}
                        </div>
                      )
                    })}
                  </Flex>
                ) : (
                  Object.entries(item[1]).map(([key, value]) => (
                    <Flex align="start" vertical gap="8px" className="w-100">
                      <span className="gray-900 fs12">{`${t("Media Type")}: ${t(convertToReadableString(key))}`}</span>
                      <Divider style={{ marginBlock: 0 }} />
                      <Flex align="start" gap="8px">
                        {createFileList(value)?.map(e => {
                          const mediaItem = media.find(item => item.id === e.id)

                          return (
                            <div style={{ position: "relative", display: "inline-block" }}>
                              <Checkbox
                                checked={mediaItem?.checkedState}
                                onChange={value => {
                                  handleChange(value.target.checked, e)
                                }}
                                className={styles.checkboxStyle}
                              />
                              {RenderMedia(e)}
                            </div>
                          )
                        })}
                      </Flex>
                    </Flex>
                  ))
                )}
              </Flex>
              {/* <Divider style={{ marginBlock: "12px" }} /> */}
            </div>
          )
        )
      })}
      {!!downloadUrls.length && (
        <div className={styles.modalBar}>
          <Flex justify="space-between">
            <span style={{ color: theme["accent-color-alt"], marginInlineStart: 5 }}>
              {t("Selected")} ({downloadUrls.length})
            </span>
            <Space>
              <Button
                text={t("Cancel")}
                onClick={handleCancelClick}
                style={{ "--btn-bg": "#fff" }}
                // size="small"
              />
              <Button
                text={t("Download")}
                type="primary"
                onClick={downloadMedia}
                style={{ marginInlineEnd: 5 }}
                // size="small"
              />
            </Space>
          </Flex>
        </div>
      )}
    </div>
  )
}

export default MediaTab
